"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const breakpoints = {
    xs: 320,
    s: 480,
    m: 768,
    l: 1024,
    xl: 1200,
    max: 1201,
};
exports.default = breakpoints;
//# sourceMappingURL=breakpoints.js.map